'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ReverseButton = exports.AdvanceButton = undefined;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _button = require('react-toolbox/lib/button');

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _setDisplayName = require('recompose/setDisplayName');

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _withStepper = require('./with-stepper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
var AdvanceButton = exports.AdvanceButton = (0, _compose2.default)(_withStepper.withStepper, (0, _setDisplayName2.default)('AdvanceButton'))(function (_a) {
    var _ = _a.canReverse,
        __ = _a.pageState,
        ___ = _a.setPageState,
        pages = _a.pages,
        canAdvance = _a.canAdvance,
        currentPage = _a.currentPage,
        setPageIndex = _a.setPageIndex,
        disabled = _a.disabled,
        _onClick = _a.onClick,
        onNext = _a.onNext,
        onFinish = _a.onFinish,
        finishLabel = _a.finishLabel,
        children = _a.children,
        props = __rest(_a, ["canReverse", "pageState", "setPageState", "pages", "canAdvance", "currentPage", "setPageIndex", "disabled", "onClick", "onNext", "onFinish", "finishLabel", "children"]);

    var isLast = finishLabel && currentPage + 1 >= pages.length;
    return React.createElement(_button.Button, __assign({ disabled: disabled || !isLast && !canAdvance }, props, { onClick: function onClick(e) {
            if (currentPage + 1 >= pages.length) {
                if (onFinish) {
                    onFinish();
                }
            } else {
                if (onNext) {
                    onNext();
                }
                setPageIndex(currentPage + 1);
            }
            if (_onClick) return _onClick(e);
        } }), finishLabel && currentPage + 1 >= pages.length ? finishLabel : children);
});
var ReverseButton = exports.ReverseButton = (0, _compose2.default)(_withStepper.withStepper, (0, _setDisplayName2.default)('ReverseButton'))(function (_a) {
    var _ = _a.canAdvance,
        __ = _a.pages,
        ___ = _a.pageState,
        ____ = _a.setPageState,
        canReverse = _a.canReverse,
        currentPage = _a.currentPage,
        setPageIndex = _a.setPageIndex,
        disabled = _a.disabled,
        _onClick2 = _a.onClick,
        onPrevious = _a.onPrevious,
        onCancel = _a.onCancel,
        cancelLabel = _a.cancelLabel,
        children = _a.children,
        props = __rest(_a, ["canAdvance", "pages", "pageState", "setPageState", "canReverse", "currentPage", "setPageIndex", "disabled", "onClick", "onPrevious", "onCancel", "cancelLabel", "children"]);

    return React.createElement(_button.Button, __assign({ disabled: disabled || !cancelLabel && !canReverse }, props, { onClick: function onClick(e) {
            if (currentPage <= 0) {
                if (onCancel) {
                    onCancel();
                }
            } else {
                if (onPrevious) {
                    onPrevious();
                }
                setPageIndex(currentPage - 1);
            }
            if (_onClick2) return _onClick2(e);
        } }), cancelLabel && currentPage <= 0 ? cancelLabel : children);
});
//# sourceMappingURL=react-toolbox.js.map



//////////////////
// WEBPACK FOOTER
// ./dist/src/react-toolbox.js
// module id = 837
// module chunks = 0